<template>
  <div id="login_page"></div>
</template>
<script>
// import firebase from "firebase/app";
// import routes from "@/router";
export default {
  async created() {
    // @todo log to firebase for see data from hook
    const sso = localStorage.getItem("sso") == "Y";
    // if (sso) {
      this.$store.dispatch("sso/logoutCallback", {
        email: localStorage.getItem("sso_email"),
        providerId: localStorage.getItem("sso_provider_id"),
      })
    // }
  },
};
</script>
